import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import UserPanel from "./Routes/router";
import AlertMessage from "./components/alert/AlertMessage";
import "@fontsource/poppins";

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <AlertMessage />
        <UserPanel />
      </ThemeProvider>
    </>
  );
}

export default App;
